import TicketsComponent from '../components/tickets/tickets'

const Tickets = () => <TicketsComponent />

export default Tickets;